import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busNhaXeApi } from "../../../api/bus/busNhaXeApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eBusNhaXeActionTypeIds, IBusNhaXeDeleteStart, IBusNhaXeSaveStart } from "../../action-types/bus/IBusNhaXeActionTypes";
import { busNhaXeActions } from "../../actions/bus/busNhaXeActions";

export function* busNhaXeSaga(): any {
	yield takeLatest(eBusNhaXeActionTypeIds.LOAD_START, loadBusNhaXeWorker)
	yield takeEvery(eBusNhaXeActionTypeIds.DELETE_START, deleteBusNhaXeWorker)
	yield takeEvery(eBusNhaXeActionTypeIds.SAVE_START, saveBusNhaXeWorker)
}

function* loadBusNhaXeWorker(): any {
	const res: IBaseResponeModel = yield call([busNhaXeApi, busNhaXeApi.SelectAll])
	if (res.is_success) {
		yield put(busNhaXeActions.loadBusNhaXeSuccess(res.data))
	} else {
		yield put(busNhaXeActions.loadBusNhaXeError(res.message || "Không tải được danh sách nhà xe"))
	}
}

function* deleteBusNhaXeWorker(action: IBusNhaXeDeleteStart): any {
	const res: IBaseResponeModel = yield call([busNhaXeApi, busNhaXeApi.Delete], action.payload)
	if (res.is_success) {
		yield put(busNhaXeActions.deleteBusNhaXeSuccess())
	} else {
		yield put(busNhaXeActions.deleteBusNhaXeErr(res.message || "Không xoá được nhà xe"))
	}
}

function* saveBusNhaXeWorker(action: IBusNhaXeSaveStart): any {
	let res: IBaseResponeModel;
	if (action.payload.id > 0) {
		res = yield call([busNhaXeApi, busNhaXeApi.Update], action.payload);
	} else {
		res = yield call([busNhaXeApi, busNhaXeApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busNhaXeActions.saveBusNhaXeSuccess())
	} else {
		yield put(busNhaXeActions.saveBusNhaXeError(res.message || "Không lưu được nhà xe"))
	}
}
